import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import {Autoplay, Pagination} from 'swiper/modules';

const initFatSalesBanners = () => {
    const sliders = document.querySelectorAll('.js-fat-sales-banners');

    if (!sliders.length) {
        return;
    }

    sliders.forEach((slider) => {
        const slides = slider.querySelectorAll('.swiper-slide');

        if (slides.length <= 1) {
            return;
        }

        const editMode = slider.dataset.editMode === '1';

        new Swiper(slider, {
            modules: [Autoplay, Pagination],
            // В режиме правки loop клонирует слайды и ломает Bitrix edit-area id
            loop: !editMode,
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 16,
            watchOverflow: true,
            observer: true,
            observeParents: true,

            autoplay: editMode
                ? false
                : {
                      delay: 3500,
                      disableOnInteraction: false,
                  },

            pagination: {
                el: slider.querySelector('.fat-sales-banners-carousel__dots'),
                clickable: true,
                bulletClass: 'fat-sales-banners-carousel__dot',
                bulletActiveClass: 'active',
            },

            breakpoints: {
                961: {
                    spaceBetween: 30,
                },
            },
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFatSalesBanners);
} else {
    initFatSalesBanners();
}
